'use client'
import { CategoryMappingModule } from '@repo/hmrc-itsa/CategoryMappingModule'

const HmrcItsaCategoryMapping = () => {
  return <CategoryMappingModule />
}

export default HmrcItsaCategoryMapping
